export const sequence = (num: number) => Array.from(Array(num), (_, i) => i);
